<div class="page-title sds-register-title">
  <span>
    <span [translate]="'SDS_EXPOSURE_REGISTER'"></span>
  </span>
  <span class="page-actions sds-register-actions">
    <!-- Register requirement: forskrift om utførelse av arbeid kapittel 31, § 31-2. -->
    <app-sds-legal-reference reference="exposure"></app-sds-legal-reference>

    <button
      class="btn btn-outline-secondary btn-sm"
      (click)="refresh()"
      [disabled]="loading"
    >
      <i class="pi pi-refresh"></i>
      <span [translate]="'REFRESH'"></span>
    </button>
    <!-- Export — a single button opening a dropdown of formats. Register exports prompt for a reason and are audited. -->
    <button
      class="btn btn-outline-primary btn-sm sds-export-trigger"
      type="button"
      (click)="openExportMenu($event)"
      [disabled]="!canExport"
    >
      <i
        class="pi"
        [ngClass]="exportLoading ? 'pi-spin pi-spinner' : 'pi-download'"
      ></i>
      <span [translate]="'EXPORT'"></span>
      <i class="pi pi-angle-down sds-export-caret"></i>
    </button>
    <p-menu
      #exportMenu
      [popup]="true"
      [model]="exportMenuItems"
      appendTo="body"
      styleClass="sds-actions-menu"
    ></p-menu>
  </span>
</div>

<!-- ═══════════ TABS ═══════════ -->
<div class="sds-register-tabs">
  <button
    type="button"
    class="sds-register-tab"
    [class.is-active]="activeTab === 'register'"
    (click)="selectTab('register')"
  >
    <i class="pi pi-table"></i>
    <span [translate]="'SDS_EXPOSURE_REGISTER_TAB'"></span>
  </button>
  <button
    *ngIf="canAccessPii"
    type="button"
    class="sds-register-tab"
    [class.is-active]="activeTab === 'log'"
    (click)="selectTab('log')"
  >
    <i class="pi pi-history"></i>
    <span [translate]="'SDS_EXPOSURE_ACCESS_LOG_TAB'"></span>
  </button>
</div>

<div class="sds-register-help" *ngIf="activeTab === 'register'">
  <i class="pi pi-info-circle"></i>
  <span [translate]="'SDS_EXPOSURE_REGISTER_HELP'"></span>
</div>

<!-- ═══════════ ERROR / EMPTY STATES ═══════════ -->
<div class="sds-register-error" *ngIf="activeTab === 'register' && error">
  <i class="pi pi-exclamation-triangle"></i>
  <span>{{ error }}</span>
</div>

<!-- ═══════════ MAIN GRID ═══════════ -->
<div
  class="table-view sds-register-table-wrapper mbtm-30"
  *ngIf="activeTab === 'register'"
>
  <p-table
    #registerTable
    [value]="rows"
    dataKey="ExposureId"
    [loading]="loading"
    [rows]="15"
    [paginator]="true"
    [pageLinks]="3"
    [rowsPerPageOptions]="[10, 15, 30, 50]"
    paginatorDropdownAppendTo="body"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="{{ 'SUMMARY_TOTALRECORDS' | translate }}"
    [globalFilterFields]="[
      'FirstName',
      'LastName',
      'ProductName',
      'Supplier',
      'CASNumber',
      'MedicalExamDoctorName'
    ]"
    responsiveLayout="scroll"
    styleClass="p-datatable-sm sds-register-table sds-modern-table"
    [scrollable]="true"
    sortField="UpdatedAt"
    [sortOrder]="-1"
  >
    <!-- ─── Caption / global search ─── -->
    <ng-template pTemplate="caption">
      <div class="sds-register-caption">
        <p-iconfield class="sds-search-field">
          <p-inputicon styleClass="pi pi-search" />
          <input
            pInputText
            type="text"
            [placeholder]="'SDS_EXPOSURE_REGISTER_SEARCH' | translate"
            (input)="applyGlobalFilter($any($event.target)?.value)"
            class="sds-register-search"
          />
        </p-iconfield>
        <span class="sds-register-count" *ngIf="!loading">
          {{ rows.length }} {{ "SDS_EXPOSURE_REGISTER_ROWS" | translate }}
        </span>
      </div>
    </ng-template>

    <!-- ─── Header ─── -->
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="ProductName" style="min-width: 200px">
          {{ "SDS_PRODUCT_NAME" | translate }}
          <p-sortIcon field="ProductName"></p-sortIcon>
        </th>
        <th pSortableColumn="LastName" style="min-width: 180px">
          {{ "SDS_EMPLOYEE" | translate }}
          <p-sortIcon field="LastName"></p-sortIcon>
        </th>
        <th style="min-width: 140px">
          {{ "SDS_NIN" | translate }}
        </th>
        <th pSortableColumn="HazardCategory" style="min-width: 160px">
          {{ "SDS_HAZARD_CATEGORY" | translate }}
          <p-sortIcon field="HazardCategory"></p-sortIcon>
        </th>
        <th pSortableColumn="ExposureStartDate" style="min-width: 120px">
          {{ "SDS_EXPOSURE_START_DATE" | translate }}
          <p-sortIcon field="ExposureStartDate"></p-sortIcon>
        </th>
        <th pSortableColumn="ExposureEndDate" style="min-width: 120px">
          {{ "SDS_EXPOSURE_END_DATE" | translate }}
          <p-sortIcon field="ExposureEndDate"></p-sortIcon>
        </th>
        <th pSortableColumn="RetentionExpiryDate" style="min-width: 150px">
          {{ "SDS_RETENTION" | translate }}
          <p-sortIcon field="RetentionExpiryDate"></p-sortIcon>
        </th>
      </tr>
    </ng-template>

    <!-- ─── Body ─── -->
    <ng-template pTemplate="body" let-row>
      <tr>
        <!-- Chemical (clickable → opens the SDS document) -->
        <td>
          <div class="sds-register-product-cell">
            <span
              class="sds-register-product-link"
              (click)="openDocument(row)"
              [pTooltip]="'SDS_OPEN_DOCUMENT' | translate"
              tooltipPosition="top"
            >
              {{ row.ProductName }}
              <i class="pi pi-external-link sds-register-product-link-icon"></i>
            </span>
            <small *ngIf="row.Supplier" class="sds-register-product-supplier">
              {{ row.Supplier }}
            </small>
            <small
              *ngIf="row.CASNumber"
              class="sds-register-product-cas"
              [pTooltip]="row.CASNumber"
              tooltipPosition="top"
            >
              CAS&nbsp;{{ row.CASNumber }}
            </small>
          </div>
        </td>

        <!-- Employee -->
        <td>
          <span class="sds-register-employee">
            <i class="pi pi-user"></i>
            <span class="sds-register-employee-name">{{
              displayName(row)
            }}</span>
          </span>
        </td>

        <!-- NIN — masked, with reveal button -->
        <td>
          <ng-container
            *ngIf="row.NationalIdentityNumberMasked; else ninUnavailable"
          >
            <span
              class="sds-register-nin-masked"
              [pTooltip]="'SDS_NIN_MASKED_TOOLTIP' | translate"
              tooltipPosition="top"
            >
              {{ row.NationalIdentityNumberMasked }}
            </span>
            <button
              class="btn btn-link btn-sm sds-register-reveal-btn"
              type="button"
              (click)="startReveal(row)"
              [pTooltip]="'SDS_REVEAL_NIN_TOOLTIP' | translate"
              tooltipPosition="top"
            >
              <i class="pi pi-eye"></i>
            </button>
          </ng-container>
          <ng-template #ninUnavailable>
            <span
              class="sds-register-nin-empty"
              [translate]="'SDS_NIN_NOT_AVAILABLE'"
            ></span>
          </ng-template>
        </td>

        <!-- Hazard category -->
        <td>
          <span
            class="sds-register-hazard-badge"
            [attr.data-cat]="row.HazardCategory"
          >
            {{ hazardLabelKey(row.HazardCategory) | translate }}
          </span>
        </td>

        <!-- Start / end -->
        <td>
          {{ (row.ExposureStartDate | date: "dd/MM/yyyy") || "—" }}
        </td>
        <td>
          <span *ngIf="row.ExposureEndDate; else ongoing">
            {{ row.ExposureEndDate | date: "dd/MM/yyyy" }}
          </span>
          <ng-template #ongoing>
            <span
              class="sds-register-ongoing-pill"
              [translate]="'SDS_RETENTION_ONGOING'"
            ></span>
          </ng-template>
        </td>

        <!-- Retention status badge + expiry date -->
        <td>
          <div class="sds-register-retention-cell">
            <span
              class="sds-register-retention-badge"
              [ngClass]="retentionStatus(row).cssClass"
            >
              {{ retentionStatus(row).labelKey | translate }}
            </span>
            <small
              *ngIf="row.RetentionExpiryDate"
              class="sds-register-retention-date"
            >
              {{ row.RetentionExpiryDate | date: "dd/MM/yyyy" }}
            </small>
          </div>
        </td>
      </tr>
    </ng-template>

    <!-- ─── Empty state ─── -->
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="7" class="sds-register-empty">
          <i class="pi pi-inbox"></i>
          <span [translate]="'SDS_EXPOSURE_REGISTER_EMPTY'"></span>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- ═══════════ ACCESS LOG TAB ═══════════ -->
<div *ngIf="activeTab === 'log'">
  <div class="sds-register-help">
    <i class="pi pi-info-circle"></i>
    <span [translate]="'SDS_EXPOSURE_ACCESS_LOG_HELP'"></span>
  </div>

  <div class="sds-register-error" *ngIf="accessLogError">
    <i class="pi pi-exclamation-triangle"></i>
    <span>{{ accessLogError }}</span>
  </div>

  <div class="table-view sds-register-table-wrapper mbtm-30">
    <p-table
      #logTable
      [value]="accessLogRows"
      dataKey="Id"
      [loading]="accessLogLoading"
      [rows]="20"
      [paginator]="true"
      [pageLinks]="3"
      [rowsPerPageOptions]="[10, 20, 50, 100]"
      paginatorDropdownAppendTo="body"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{{ 'SUMMARY_TOTALRECORDS' | translate }}"
      [globalFilterFields]="[
        'AccessedByName',
        'EmployeeName',
        'ProductName',
        'Reason',
        'IpAddress'
      ]"
      styleClass="p-datatable-sm sds-register-table sds-modern-table"
      sortField="AccessedOnUtc"
      [sortOrder]="-1"
    >
      <ng-template pTemplate="caption">
        <div class="sds-register-caption">
          <p-iconfield class="sds-search-field">
            <p-inputicon styleClass="pi pi-search" />
            <input
              #logSearch
              pInputText
              type="text"
              [placeholder]="'SDS_EXPOSURE_ACCESS_LOG_SEARCH' | translate"
              (input)="logTable.filterGlobal(logSearch.value, 'contains')"
              class="sds-register-search"
            />
          </p-iconfield>
          <span class="sds-register-count" *ngIf="!accessLogLoading">
            {{ accessLogRows.length }}
            {{ "SDS_EXPOSURE_ACCESS_LOG_ROWS" | translate }}
          </span>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="AccessedOnUtc" style="min-width: 160px">
            {{ "SDS_ACCESS_LOG_WHEN" | translate }}
            <p-sortIcon field="AccessedOnUtc"></p-sortIcon>
          </th>
          <th pSortableColumn="AccessedByName" style="min-width: 160px">
            {{ "SDS_ACCESS_LOG_BY" | translate }}
            <p-sortIcon field="AccessedByName"></p-sortIcon>
          </th>
          <th style="min-width: 180px">
            {{ "SDS_ACCESS_LOG_TARGET" | translate }}
          </th>
          <th style="min-width: 240px">
            {{ "SDS_ACCESS_LOG_REASON" | translate }}
          </th>
          <th style="min-width: 120px">
            {{ "SDS_ACCESS_LOG_IP" | translate }}
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-row>
        <tr>
          <td>{{ formatLogTime(row.AccessedOnUtc) }}</td>
          <td>
            <span class="sds-register-employee">
              <i class="pi pi-user"></i>
              <span class="sds-register-employee-name">{{
                row.AccessedByName || "#" + row.AccessedByUserId
              }}</span>
            </span>
          </td>
          <td>
            <div class="sds-register-product-cell">
              <span class="sds-register-employee-name">{{
                row.EmployeeName || "—"
              }}</span>
              <small
                *ngIf="row.ProductName"
                class="sds-register-product-supplier"
              >
                {{ row.ProductName }}
              </small>
            </div>
          </td>
          <td>
            <span *ngIf="row.Reason; else noReason">{{
              displayAccessReason(row.Reason)
            }}</span>
            <ng-template #noReason>
              <span class="sds-register-nin-empty">—</span>
            </ng-template>
          </td>
          <td>{{ row.IpAddress || "—" }}</td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5" class="sds-register-empty">
            <i class="pi pi-inbox"></i>
            <span [translate]="'SDS_EXPOSURE_ACCESS_LOG_EMPTY'"></span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<!-- ═══════════ REVEAL DIALOG ═══════════ -->
<p-dialog
  [header]="'SDS_REVEAL_NIN_DIALOG_TITLE' | translate"
  [(visible)]="revealDialogVisible"
  [style]="{ width: '520px', maxWidth: '94vw' }"
  [baseZIndex]="10000"
  [resizable]="false"
  [draggable]="false"
  [modal]="true"
  [closable]="!revealDialogLoading"
  styleClass="sds-reveal-dialog"
  (onHide)="closeRevealDialog()"
>
  <div class="sds-reveal-dialog-body">
    <div class="sds-reveal-warning">
      <i class="pi pi-shield"></i>
      <span [translate]="'SDS_REVEAL_NIN_DIALOG_BODY'"></span>
    </div>

    <div class="sds-reveal-target" *ngIf="revealDialogRow">
      <strong>{{ displayName(revealDialogRow) }}</strong>
      <span class="sds-reveal-target-product">
        · {{ revealDialogRow.ProductName }}
      </span>
    </div>

    <div class="sds-reveal-field">
      <label class="sds-field-label">
        {{ "SDS_REVEAL_NIN_REASON_LABEL" | translate }}
        <span class="sds-required-marker" aria-hidden="true">*</span>
      </label>
      <textarea
        pTextarea
        [(ngModel)]="revealDialogReason"
        rows="3"
        maxlength="500"
        [disabled]="revealDialogLoading || !!revealedNin"
        [placeholder]="'SDS_REVEAL_NIN_REASON_PLACEHOLDER' | translate"
        (input)="revealError = null"
      ></textarea>
      <div class="sds-reveal-reason-meta">
        <small
          class="sds-field-hint"
          [translate]="'SDS_REVEAL_NIN_REASON_HELP'"
        ></small>
        <small
          class="sds-reveal-reason-counter"
          [class.is-short]="!reasonMeetsMinimum"
          [class.is-ok]="reasonMeetsMinimum"
          [attr.aria-live]="'polite'"
        >
          {{ reasonLength }}/{{ minReasonLength }}
        </small>
      </div>
      <small
        *ngIf="revealError"
        class="sds-field-error sds-reveal-inline-error"
        role="alert"
      >
        <i class="pi pi-times-circle"></i>
        <span>{{ revealError }}</span>
      </small>
    </div>

    <div *ngIf="revealedNin" class="sds-reveal-result">
      <i class="pi pi-check-circle"></i>
      <span>{{ revealedNin }}</span>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button
      class="btn btn-outline-secondary"
      type="button"
      (click)="closeRevealDialog()"
      [disabled]="revealDialogLoading"
    >
      <span [translate]="'CLOSE'"></span>
    </button>
    <button
      *ngIf="!revealedNin"
      class="btn btn-primary"
      type="button"
      (click)="confirmReveal()"
      [disabled]="revealDialogLoading || !reasonMeetsMinimum"
      [pTooltip]="
        !reasonMeetsMinimum
          ? ('SDS_REVEAL_NIN_REASON_TOO_SHORT' | translate)
          : null
      "
      tooltipPosition="top"
    >
      <i *ngIf="!revealDialogLoading" class="pi pi-eye"></i>
      <i *ngIf="revealDialogLoading" class="pi pi-spin pi-spinner"></i>
      <span [translate]="'SDS_REVEAL_NIN'"></span>
    </button>
  </ng-template>
</p-dialog>

<!-- ═══════════ EXPORT REASON DIALOG (Register only) ═══════════ -->
<p-dialog
  [header]="'SDS_EXPOSURE_EXPORT_REASON_TITLE' | translate"
  [(visible)]="exportReasonDialogVisible"
  [style]="{ width: '520px', maxWidth: '94vw' }"
  [baseZIndex]="10000"
  [resizable]="false"
  [draggable]="false"
  [modal]="true"
  [closable]="!exportLoading"
  styleClass="sds-reveal-dialog"
  (onHide)="closeExportDialog()"
>
  <div class="sds-reveal-dialog-body">
    <div class="sds-reveal-warning">
      <i class="pi pi-shield"></i>
      <span [translate]="'SDS_EXPOSURE_EXPORT_REASON_BODY'"></span>
    </div>

    <div class="sds-reveal-field">
      <label class="sds-field-label">
        {{ "SDS_EXPOSURE_EXPORT_REASON_LABEL" | translate }}
        <span class="sds-required-marker" aria-hidden="true">*</span>
      </label>
      <textarea
        pTextarea
        [(ngModel)]="exportReasonText"
        rows="3"
        maxlength="500"
        [disabled]="exportLoading"
        [placeholder]="'SDS_EXPOSURE_EXPORT_REASON_PLACEHOLDER' | translate"
        (input)="exportReasonError = null"
      ></textarea>
      <div class="sds-reveal-reason-meta">
        <small
          class="sds-field-hint"
          [translate]="'SDS_REVEAL_NIN_REASON_HELP'"
        ></small>
        <small
          class="sds-reveal-reason-counter"
          [class.is-short]="exportReasonText.trim().length < minReasonLength"
          [class.is-ok]="exportReasonText.trim().length >= minReasonLength"
        >
          {{ exportReasonText.trim().length }}/{{ minReasonLength }}
        </small>
      </div>
      <small
        *ngIf="exportReasonError"
        class="sds-field-error sds-reveal-inline-error"
        role="alert"
      >
        <i class="pi pi-times-circle"></i>
        <span>{{ exportReasonError }}</span>
      </small>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button
      class="btn btn-outline-secondary"
      type="button"
      (click)="closeExportDialog()"
      [disabled]="exportLoading"
    >
      <span [translate]="'CANCEL'"></span>
    </button>
    <button
      class="btn btn-primary"
      type="button"
      (click)="confirmRegisterExport()"
      [disabled]="
        exportLoading || exportReasonText.trim().length < minReasonLength
      "
    >
      <i *ngIf="!exportLoading" class="pi pi-download"></i>
      <i *ngIf="exportLoading" class="pi pi-spin pi-spinner"></i>
      <span [translate]="'EXPORT'"></span>
    </button>
  </ng-template>
</p-dialog>

